import { Ref } from 'vue'
import { IEmbarcacion, OperatedEmbarcacion } from '../../../services/api-services/EmbarcacionesServices'
import { IRequest, RequestStatus } from '../../../services/api-services/RequestsServices'
import { IService, OperatedService } from '../../../services/api-services/ServicesServices'
import {
  ITarifa,
  TarifaEspecial,
  UnidadMedidaAplicada,
  UnidadMedidaTarifa,
} from '../../../services/api-services/TarifasServices'
import { IViaje, OperatedViaje, ViajeMuelle } from '../../../services/api-services/ViajesServices'
import dataStorageManager, { BucketDefaultIDs } from '../../data/DataStorageManager'
import MotorMatematico from '../MotorMatematico'
import { CobroEstado, CobroMuelle, ICobro, OperatedCobro } from '../../../services/api-services/CobrosServices'

interface TarifaSelectorEntry {
  viaje?: IViaje
  servicio?: OperatedService
  counter: number
  embarcacion?: IEmbarcacion
}

const tarifaSelector = new Map<string, (data: TarifaSelectorEntry) => boolean>([
  [
    '90111200',
    (data: TarifaSelectorEntry) => {
      if (
        data.viaje &&
        (data.viaje.muelle === ViajeMuelle.ESTE || data.viaje.autorizado == 1) &&
        data.embarcacion &&
        data.embarcacion.convenio === 1
      ) {
        return true
      }
      return false
    },
  ],
  [
    '90111400',
    (data: TarifaSelectorEntry) => {
      if (data.viaje && data.viaje.muelle === ViajeMuelle.WESTE && data.viaje.autorizado != 1 && data.embarcacion) {
        return true
      }
      return false
    },
  ],
  [
    '90111410',
    (data: TarifaSelectorEntry) => {
      if (
        data.viaje &&
        data.viaje.muelle === ViajeMuelle.ESTE &&
        data.embarcacion &&
        data.embarcacion.convenio !== 1 &&
        data.counter == 1
      ) {
        return true
      }
      return false
    },
  ],
  [
    '90111420',
    (data: TarifaSelectorEntry) => {
      if (
        data.viaje &&
        data.viaje.muelle === ViajeMuelle.ESTE &&
        data.embarcacion &&
        data.embarcacion.convenio !== 1 &&
        data.counter > 1
      ) {
        return true
      }
      return false
    },
  ],
  [
    '90111500',
    (data: TarifaSelectorEntry) => {
      if (
        data.servicio &&
        data.servicio.requestData &&
        data.servicio.requestData.tipo_objeto_2 === null &&
        data.counter == 1
      ) {
        return true
      }
      return false
    },
  ],
  [
    '90111510',
    (data: TarifaSelectorEntry) => {
      if (
        data.servicio &&
        data.servicio.requestData &&
        data.servicio.requestData.tipo_objeto_2 === null &&
        data.counter == 2
      ) {
        return true
      }
      return false
    },
  ],
  [
    '90111520',
    (data: TarifaSelectorEntry) => {
      if (
        data.servicio &&
        data.servicio.requestData &&
        data.servicio.requestData.tipo_objeto_2 === null &&
        data.counter > 2
      ) {
        return true
      }
      return false
    },
  ],
  [
    '90111700',
    (data: TarifaSelectorEntry) => {
      if (
        data.servicio &&
        data.servicio.requestData &&
        data.servicio.requestData.tipo_objeto_2 === 'tarifa_especial' &&
        data.servicio.requestData.id_objeto_2
      ) {
        if (data.embarcacion) {
          if (
            data.embarcacion.tipo_embarcacion === 'auxiliar' &&
            data.servicio.requestData.id_objeto_2.toString() === TarifaEspecial.AUXILIAR.toString()
          ) {
            return true
          }
        } else {
          if (
            data.servicio.tipo_embarcacion === 'auxiliar' &&
            data.servicio.requestData.id_objeto_2.toString() === TarifaEspecial.AUXILIAR.toString()
          ) {
            return true
          }
        }
        return true
      }
      return false
    },
  ],
  [
    '90111710',
    (data: TarifaSelectorEntry) => {
      if (
        data.servicio &&
        data.servicio.requestData &&
        data.servicio.requestData.tipo_objeto_2 === 'tarifa_especial' &&
        data.servicio.requestData.id_objeto_2
      ) {
        if (data.embarcacion) {
          if (
            data.embarcacion.tipo_embarcacion === 'pilotaje' &&
            data.servicio.requestData.id_objeto_2.toString() === TarifaEspecial.PILOTAJE.toString()
          ) {
            return true
          }
        } else {
          if (
            data.servicio.tipo_embarcacion === 'pilotaje' &&
            data.servicio.requestData.id_objeto_2.toString() === TarifaEspecial.PILOTAJE.toString()
          ) {
            return true
          }
        }
        return true
      }
      return false
    },
  ],
  [
    '90111720',
    (data: TarifaSelectorEntry) => {
      if (
        data.servicio &&
        data.servicio.requestData &&
        data.servicio.requestData.tipo_objeto_2 === 'tarifa_especial' &&
        data.servicio.requestData.id_objeto_2
      ) {
        if (data.servicio.requestData.id_objeto_2.toString() === TarifaEspecial.BUQUE_GIRA.toString()) {
          return true
        }
        return true
      }
      return false
    },
  ],
])

const sapCodesList = Array.from(tarifaSelector.keys())

export default class OperadorTarifas {
  private tarifasData: Ref<ITarifa[]>
  private embarcacionesData: Ref<IEmbarcacion[]> = dataStorageManager.subscribeBucket<IEmbarcacion>(
    BucketDefaultIDs.EMBARCACIONES,
    () => {},
  )
  private motorTarifas: MotorMatematico | null = null

  constructor() {
    this.tarifasData = dataStorageManager.subscribeBucket<ITarifa>(BucketDefaultIDs.TARIFAS, (tarifas) => {
      this.motorTarifas = new MotorMatematico(tarifas)
    })
    //if (this.tarifasData.value.length > 0) this.motorTarifas = new MotorMatematico(this.tarifasData.value)
  }

  public startup() {}

  public getCobroRangoTiempo(
    fechaInicio: Date,
    fechaFin: Date,
    viajes: OperatedViaje[],
    servicios: OperatedService[],
  ): OperatedCobro[] {
    const cobros: OperatedCobro[] = []
    const currentViajes = viajes
      .filter((v) => v.posicionamientosData.length > 0) // Solo considerar viajes con posicionamientos
      .filter((v) => {
        const viajeFecha = new Date(v.fecha_viaje)
        return viajeFecha >= fechaInicio && viajeFecha <= fechaFin
      })
    const currentServicios = servicios.filter((s) => {
      const servicioFecha = new Date(s.fecha_inicio)
      return servicioFecha >= fechaInicio && servicioFecha <= fechaFin
    })

    const viajesMuelleEste = currentViajes.filter((v) => v.muelle === ViajeMuelle.ESTE)
    if (viajesMuelleEste.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: viajesMuelleEste.length,
        viaje: viajesMuelleEste[0],
        embarcacion: this.embarcacionesData.value.find((e) => e.id === viajesMuelleEste[0].embarcacion_id),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = viajesMuelleEste.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          viajesMuelleEste.forEach((v) => {
            const viajeDate = new Date(v.fecha_viaje)
            const dayString = viajeDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          // Regla FA-3: Embarcaciones de turismo con convenio tienen cobro a partir del octavo día
          if (selectorEntry.embarcacion && selectorEntry.embarcacion.convenio === 1) {
            unidadesValue = Math.max(0, uniqueDays.size - 7)
          } else {
            unidadesValue = uniqueDays.size
          }
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = viajesMuelleEste.length * 2 // Asumiendo 2 toques por viaje
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(viajesMuelleEste.map((v) => new Date(v.fecha_viaje)))
        } // Si es ZPE, se mantiene el conteo de viajes, un zarpe por viaje
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0

        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.ESTE,
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: 0,
          id_armador: viajesMuelleEste[0].id_armador,
          id_embarcacion: viajesMuelleEste[0].embarcacion_id,
          cobrosRequests: [],
          viajesApplied: viajesMuelleEste,
          servicesApplied: [],
          valor_total: valorTotal,
        })
      }
    }

    const viajesMuelleWesteSinPermiso = currentViajes.filter(
      (v) =>
        v.muelle === ViajeMuelle.WESTE &&
        (!v.permisoMuelleWesteData || v.permisoMuelleWesteData.estado !== RequestStatus.APPROVED),
    )
    if (viajesMuelleWesteSinPermiso.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: viajesMuelleWesteSinPermiso.length,
        viaje: viajesMuelleWesteSinPermiso[0],
        embarcacion: this.embarcacionesData.value.find((e) => e.id === viajesMuelleWesteSinPermiso[0].embarcacion_id),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = viajesMuelleWesteSinPermiso.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          viajesMuelleWesteSinPermiso.forEach((v) => {
            const viajeDate = new Date(v.fecha_viaje)
            const dayString = viajeDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = viajesMuelleWesteSinPermiso.length * 2 // Asumiendo 2 toques por viaje
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(viajesMuelleWesteSinPermiso.map((v) => new Date(v.fecha_viaje)))
        } // Si es ZPE, se mantiene el conteo de viajes, un zarpe por viaje
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0

        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.WESTE,
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: viajesMuelleWesteSinPermiso[0].id_armador,
          id_embarcacion: viajesMuelleWesteSinPermiso[0].embarcacion_id,
          cobrosRequests: [],
          viajesApplied: viajesMuelleWesteSinPermiso,
          servicesApplied: [],
          valor_total: valorTotal,
        })
      }
    }

    const viajesMuelleWesteConPermiso = currentViajes.filter(
      (v) =>
        v.muelle === ViajeMuelle.WESTE &&
        v.permisoMuelleWesteData !== undefined &&
        v.permisoMuelleWesteData.estado === RequestStatus.APPROVED,
    )
    if (viajesMuelleWesteConPermiso.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: viajesMuelleWesteConPermiso.length,
        viaje: viajesMuelleWesteConPermiso[0],
        embarcacion: this.embarcacionesData.value.find((e) => e.id === viajesMuelleWesteConPermiso[0].embarcacion_id),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = viajesMuelleWesteConPermiso.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          viajesMuelleWesteConPermiso.forEach((v) => {
            const viajeDate = new Date(v.fecha_viaje)
            const dayString = viajeDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = viajesMuelleWesteConPermiso.length * 2 // Asumiendo 2 toques por viaje
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(viajesMuelleWesteConPermiso.map((v) => new Date(v.fecha_viaje)))
        } // Si es ZPE, se mantiene el conteo de viajes, un zarpe por viaje
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0

        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.WESTE,
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: viajesMuelleWesteConPermiso[0].id_armador,
          id_embarcacion: viajesMuelleWesteConPermiso[0].embarcacion_id,
          cobrosRequests: [],
          viajesApplied: viajesMuelleWesteConPermiso,
          servicesApplied: [],
          valor_total: valorTotal,
        })
      }
    }

    // Luego se procesan los servicios
    const servicioSinTarifaEspecial = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter((s) => s.tarifasEspecialesData.length === 0)
    if (servicioSinTarifaEspecial.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: servicioSinTarifaEspecial.length,
        servicio: servicioSinTarifaEspecial[0],
        embarcacion: this.embarcacionesData.value.find(
          (e) => e.id === servicioSinTarifaEspecial[0].id_embarcacion_prestadora!,
        ),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = servicioSinTarifaEspecial.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioSinTarifaEspecial.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioSinTarifaEspecial.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioSinTarifaEspecial.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioSinTarifaEspecial[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioSinTarifaEspecial,
          valor_total: valorTotal,
        })
      }
    }

    const servicioBuqueGira = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter(
        (s) =>
          s.tarifasEspecialesData.length > 0 &&
          s.tarifasEspecialesData[0].id_objeto_2 &&
          s.tarifasEspecialesData[0].id_objeto_2.toString() === TarifaEspecial.BUQUE_GIRA.toString(),
      )
    if (servicioBuqueGira.length > 0) {
      const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === '90111720')
      if (tarifa) {
        let unidadesValue = servicioBuqueGira.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioBuqueGira.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioBuqueGira.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioBuqueGira.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioBuqueGira[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioBuqueGira,
          valor_total: valorTotal,
        })
      }
    }

    const servicioPilotaje = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter(
        (s) =>
          s.tarifasEspecialesData.length > 0 &&
          s.tarifasEspecialesData[0].id_objeto_2 &&
          s.tarifasEspecialesData[0].id_objeto_2.toString() === TarifaEspecial.PILOTAJE.toString(),
      )
    if (servicioPilotaje.length > 0) {
      const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === '90111710')
      if (tarifa) {
        let unidadesValue = servicioPilotaje.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioPilotaje.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioPilotaje.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioPilotaje.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: 0,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioPilotaje[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioPilotaje,
          valor_total: valorTotal,
        })
      }
    }

    const servicioAuxiliar = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter(
        (s) =>
          s.tarifasEspecialesData.length > 0 &&
          s.tarifasEspecialesData[0].id_objeto_2 &&
          s.tarifasEspecialesData[0].id_objeto_2.toString() === TarifaEspecial.AUXILIAR.toString(),
      )
    if (servicioAuxiliar.length > 0) {
      const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === '90111700')
      if (tarifa) {
        let unidadesValue = servicioAuxiliar.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioAuxiliar.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioAuxiliar.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioAuxiliar.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date().toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioAuxiliar[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioAuxiliar,
          valor_total: valorTotal,
        })
      }
    }

    return cobros
  }

  public getCobrosViajes(viajes: OperatedViaje[]): OperatedCobro[] {
    const cobros: OperatedCobro[] = []
    const currentViajes = viajes

    const viajesMuelleEste = currentViajes.filter((v) => v.muelle === ViajeMuelle.ESTE)
    if (viajesMuelleEste.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: viajesMuelleEste.length,
        viaje: viajesMuelleEste[0],
        embarcacion: this.embarcacionesData.value.find((e) => e.id === viajesMuelleEste[0].embarcacion_id),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = viajesMuelleEste.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          viajesMuelleEste.forEach((v) => {
            const viajeDate = new Date(v.fecha_viaje)
            const dayString = viajeDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          // Regla FA-3: Embarcaciones de turismo con convenio tienen cobro a partir del octavo día
          if (selectorEntry.embarcacion && selectorEntry.embarcacion.convenio === 1) {
            unidadesValue = Math.max(0, uniqueDays.size - 7)
          } else {
            unidadesValue = uniqueDays.size
          }
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = viajesMuelleEste.length * 2 // Asumiendo 2 toques por viaje
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(viajesMuelleEste.map((v) => new Date(v.fecha_viaje)))
        } // Si es ZPE, se mantiene el conteo de viajes, un zarpe por viaje
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(selectorEntry.viaje!.fecha_viaje).toISOString(),
          muelle: CobroMuelle.ESTE,
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: 0,
          id_armador: viajesMuelleEste[0].id_armador,
          id_embarcacion: viajesMuelleEste[0].embarcacion_id,
          cobrosRequests: [],
          viajesApplied: viajesMuelleEste,
          servicesApplied: [],
          valor_total: valorTotal,
        })
      }
    }

    const viajesMuelleWesteSinPermiso = currentViajes.filter(
      (v) =>
        v.muelle === ViajeMuelle.WESTE &&
        (!v.permisoMuelleWesteData || v.permisoMuelleWesteData.estado !== RequestStatus.APPROVED),
    )
    if (viajesMuelleWesteSinPermiso.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: viajesMuelleWesteSinPermiso.length,
        viaje: viajesMuelleWesteSinPermiso[0],
        embarcacion: this.embarcacionesData.value.find((e) => e.id === viajesMuelleWesteSinPermiso[0].embarcacion_id),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = viajesMuelleWesteSinPermiso.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          viajesMuelleWesteSinPermiso.forEach((v) => {
            const viajeDate = new Date(v.fecha_viaje)
            const dayString = viajeDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = viajesMuelleWesteSinPermiso.length * 2 // Asumiendo 2 toques por viaje
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(viajesMuelleWesteSinPermiso.map((v) => new Date(v.fecha_viaje)))
        } // Si es ZPE, se mantiene el conteo de viajes, un zarpe por viaje
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(selectorEntry.viaje!.fecha_viaje).toISOString(),
          muelle: CobroMuelle.WESTE,
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: viajesMuelleWesteSinPermiso[0].id_armador,
          id_embarcacion: viajesMuelleWesteSinPermiso[0].embarcacion_id,
          cobrosRequests: [],
          viajesApplied: viajesMuelleWesteSinPermiso,
          servicesApplied: [],
          valor_total: valorTotal,
        })
      }
    }

    const viajesMuelleWesteConPermiso = currentViajes.filter(
      (v) =>
        v.muelle === ViajeMuelle.WESTE &&
        v.permisoMuelleWesteData !== undefined &&
        v.permisoMuelleWesteData.estado === RequestStatus.APPROVED,
    )
    if (viajesMuelleWesteConPermiso.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: viajesMuelleWesteConPermiso.length,
        viaje: viajesMuelleWesteConPermiso[0],
        embarcacion: this.embarcacionesData.value.find((e) => e.id === viajesMuelleWesteConPermiso[0].embarcacion_id),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = viajesMuelleWesteConPermiso.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          viajesMuelleWesteConPermiso.forEach((v) => {
            const viajeDate = new Date(v.fecha_viaje)
            const dayString = viajeDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = viajesMuelleWesteConPermiso.length * 2 // Asumiendo 2 toques por viaje
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(viajesMuelleWesteConPermiso.map((v) => new Date(v.fecha_viaje)))
        } // Si es ZPE, se mantiene el conteo de viajes, un zarpe por viaje
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(selectorEntry.viaje!.fecha_viaje).toISOString(),
          muelle: CobroMuelle.WESTE,
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: viajesMuelleWesteConPermiso[0].id_armador,
          id_embarcacion: viajesMuelleWesteConPermiso[0].embarcacion_id,
          cobrosRequests: [],
          viajesApplied: viajesMuelleWesteConPermiso,
          servicesApplied: [],
          valor_total: valorTotal,
        })
      }
    }

    return cobros
  }

  public getCobrosServicios(servicios: OperatedService[]): OperatedCobro[] {
    const cobros: OperatedCobro[] = []
    const currentServicios = servicios

    // Luego se procesan los servicios
    const servicioSinTarifaEspecial = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter((s) => s.tarifasEspecialesData.length === 0)
    if (servicioSinTarifaEspecial.length > 0) {
      const selectorEntry: TarifaSelectorEntry = {
        counter: servicioSinTarifaEspecial.length,
        servicio: servicioSinTarifaEspecial[0],
        embarcacion: this.embarcacionesData.value.find(
          (e) => e.id === servicioSinTarifaEspecial[0].id_embarcacion_prestadora!,
        ),
      }
      const tarifa = this.findTarifa(selectorEntry)
      if (tarifa) {
        let unidadesValue = servicioSinTarifaEspecial.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioSinTarifaEspecial.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioSinTarifaEspecial.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioSinTarifaEspecial.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            eslora: selectorEntry.embarcacion?.eslora_metros ?? 0,
            manga: selectorEntry.embarcacion?.manga_metros ?? 0,
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(selectorEntry.servicio!.fecha_inicio).toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioSinTarifaEspecial[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioSinTarifaEspecial,
          valor_total: valorTotal,
        })
      }
    }

    const servicioBuqueGira = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter(
        (s) =>
          s.tarifasEspecialesData.length > 0 &&
          s.tarifasEspecialesData[0].id_objeto_2 &&
          s.tarifasEspecialesData[0].id_objeto_2.toString() === TarifaEspecial.BUQUE_GIRA.toString(),
      )
    if (servicioBuqueGira.length > 0) {
      const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === '90111720')
      if (tarifa) {
        let unidadesValue = servicioBuqueGira.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioBuqueGira.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioBuqueGira.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioBuqueGira.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(servicioBuqueGira[0]!.fecha_inicio).toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioBuqueGira[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioBuqueGira,
          valor_total: valorTotal,
        })
      }
    }

    const servicioPilotaje = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter(
        (s) =>
          s.tarifasEspecialesData.length > 0 &&
          s.tarifasEspecialesData[0].id_objeto_2 &&
          s.tarifasEspecialesData[0].id_objeto_2.toString() === TarifaEspecial.PILOTAJE.toString(),
      )
    if (servicioPilotaje.length > 0) {
      const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === '90111710')
      if (tarifa) {
        let unidadesValue = servicioPilotaje.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioPilotaje.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioPilotaje.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioPilotaje.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(servicioPilotaje[0]!.fecha_inicio).toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: 0,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioPilotaje[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioPilotaje,
          valor_total: valorTotal,
        })
      }
    }

    const servicioAuxiliar = currentServicios
      .filter((s) => s.requestData && s.requestData.tipo_objeto_2 === null)
      .filter(
        (s) =>
          s.tarifasEspecialesData.length > 0 &&
          s.tarifasEspecialesData[0].id_objeto_2 &&
          s.tarifasEspecialesData[0].id_objeto_2.toString() === TarifaEspecial.AUXILIAR.toString(),
      )
    if (servicioAuxiliar.length > 0) {
      const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === '90111700')
      if (tarifa) {
        let unidadesValue = servicioAuxiliar.length
        if (tarifa.unidad_medida === UnidadMedidaTarifa.DIA) {
          const uniqueDays = new Set<string>()
          servicioAuxiliar.forEach((s) => {
            const servicioDate = new Date(s.fecha_inicio)
            const dayString = servicioDate.toISOString().split('T')[0]
            uniqueDays.add(dayString)
          })
          unidadesValue = uniqueDays.size
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MMZ) {
          unidadesValue = servicioAuxiliar.length * 2 // Asumiendo 2 toques por servicio
        } else if (tarifa.unidad_medida === UnidadMedidaTarifa.MES) {
          unidadesValue = this.countUniqueMonths(servicioAuxiliar.map((s) => new Date(s.fecha_inicio)))
        } // Si es ZPE, se mantiene el conteo de servicios, un zarpe por servicio
        const valorTotal =
          this.motorTarifas!.interpretar(tarifa.codigo_sap, {
            unidad: unidadesValue,
            valor: tarifa.valor,
          }) || 0
        cobros.push({
          id: 0,
          fecha: new Date(servicioAuxiliar[0]!.fecha_inicio).toISOString(),
          muelle: CobroMuelle.WESTE, // Asumiendo que los servicios son en muelle weste
          codigo_sap: tarifa.codigo_sap,
          valor_aplicado: tarifa.valor,
          unidades_aplicadas: unidadesValue,
          fecha_registro: new Date().toISOString(),
          usuario_registro: 0,
          observaciones: null,
          estado: CobroEstado.PENDIENTE,
          id_armador: 0, // sin armador en contexto en cobros por servicio; se resuelve al persistir (onCobrosSaved)
          id_embarcacion: servicioAuxiliar[0].id_embarcacion_prestadora!,
          cobrosRequests: [],
          viajesApplied: [],
          servicesApplied: servicioAuxiliar,
          valor_total: valorTotal,
        })
      }
    }

    return cobros
  }

  public getUnitsData(
    fechaInicio: Date,
    fechaFin: Date,
    viajes: OperatedViaje[],
    servicios: OperatedService[],
  ): UnidadMedidaAplicada {
    let diaUnits = 0
    let mmzUnits = 0
    let zpeUnits = 0

    const countedDays = new Set<string>()

    const currentViajes = viajes
      .filter((v) => v.posicionamientosData.length > 0) // Solo considerar viajes con posicionamientos
      .filter((v) => {
        const viajeFecha = new Date(v.fecha_viaje)
        return viajeFecha >= fechaInicio && viajeFecha <= fechaFin
      })
    const currentServicios = servicios.filter((s) => {
      const servicioFecha = new Date(s.fecha_inicio)
      return servicioFecha >= fechaInicio && servicioFecha <= fechaFin
    })

    currentViajes.forEach((viaje) => {
      const viajeDate = new Date(viaje.fecha_viaje)
      const dayString = viajeDate.toISOString().split('T')[0]
      countedDays.add(dayString)
    })
    currentServicios.forEach((servicio) => {
      const servicioDate = new Date(servicio.fecha_inicio)
      const dayString = servicioDate.toISOString().split('T')[0]
      countedDays.add(dayString)
    })

    diaUnits = countedDays.size
    mmzUnits = currentViajes.length * 2 // Asumiendo 2 toques por viaje
    mmzUnits += currentServicios.length * 2 // Asumiendo 2 toques por servicio
    zpeUnits = currentViajes.length // Asumiendo 1 zarpe por viaje
    zpeUnits += currentServicios.length // Asumiendo 1 zarpe por servicio
    const mesUnits = this.countUniqueMonths([
      ...currentViajes.map((v) => new Date(v.fecha_viaje)),
      ...currentServicios.map((s) => new Date(s.fecha_inicio)),
    ])

    return {
      dia: diaUnits,
      mmz: mmzUnits,
      zpe: zpeUnits,
      mes: mesUnits,
    }
  }

  public getUnitsDataNoDate(viajes: OperatedViaje[], servicios: OperatedService[]): UnidadMedidaAplicada {
    let diaUnits = 0
    let mmzUnits = 0
    let zpeUnits = 0

    const countedDays = new Set<string>()
    const currentViajes = viajes.filter((v) => v.posicionamientosData.length > 0) // Solo considerar viajes con posicionamientos
    const currentServicios = servicios

    currentViajes.forEach((viaje) => {
      const viajeDate = new Date(viaje.fecha_viaje)
      const dayString = viajeDate.toISOString().split('T')[0]
      countedDays.add(dayString)
    })
    currentServicios.forEach((servicio) => {
      const servicioDate = new Date(servicio.fecha_inicio)
      const dayString = servicioDate.toISOString().split('T')[0]
      countedDays.add(dayString)
    })

    diaUnits = countedDays.size
    mmzUnits = currentViajes.length * 2 // Asumiendo 2 toques por viaje
    mmzUnits += currentServicios.length * 2 // Asumiendo 2 toques por servicio
    zpeUnits = currentViajes.length // Asumiendo 1 zarpe por viaje
    zpeUnits += currentServicios.length // Asumiendo 1 zarpe por servicio
    const mesUnits = this.countUniqueMonths([
      ...currentViajes.map((v) => new Date(v.fecha_viaje)),
      ...currentServicios.map((s) => new Date(s.fecha_inicio)),
    ])

    return {
      dia: diaUnits,
      mmz: mmzUnits,
      zpe: zpeUnits,
      mes: mesUnits,
    }
  }

  private countUniqueMonths(dates: Date[]): number {
    const uniqueMonths = new Set<string>()
    dates.forEach((date) => {
      uniqueMonths.add(date.toISOString().slice(0, 7)) // YYYY-MM
    })
    return uniqueMonths.size
  }

  private findTarifa(selectorEntry: TarifaSelectorEntry): ITarifa | null {
    let selectedTarifa = null
    let lectorPosition = 0

    while (selectedTarifa === null && lectorPosition < sapCodesList.length) {
      const sapCode = sapCodesList[lectorPosition]
      const selectorFunc = tarifaSelector.get(sapCode)
      if (selectorFunc && selectorFunc(selectorEntry)) {
        const tarifa = this.tarifasData.value.find((t) => t.codigo_sap.toString() === sapCode.toString())
        if (tarifa) {
          selectedTarifa = tarifa
        }
      }
      lectorPosition += 1
    }
    return selectedTarifa
  }
}
